export default {
  strings: {
    pluginNameGooglePhotos: 'Google Photos'
  }
};